export default __webpack_public_path__ + "static/media/instagram.fb9c8ff3.webp";